var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1898 13.9759C34.1163 13.9759 35.0049 14.344 35.66 14.9991C36.3152 15.6543 36.6833 16.5429 36.6833 17.4694V29.2774C37.7488 30.2381 38.43 31.6355 38.43 33.1901C38.43 36.0897 36.0894 38.4303 33.1898 38.4303C30.2902 38.4303 27.9495 36.0897 27.9495 33.1901C27.9495 31.6355 28.6308 30.2381 29.6963 29.2774V17.4694C29.6963 15.548 31.2684 13.9759 33.1898 13.9759ZM33.1898 15.7227C32.2291 15.7227 31.443 16.5087 31.443 17.4694V19.2161H34.9365V17.4694C34.9365 16.5087 34.1505 15.7227 33.1898 15.7227ZM20.9626 9.94093L12.2288 17.8013V31.4434H24.6307L24.4561 33.1901L24.6307 34.9368H8.73535V20.9629H3.49512L20.9626 5.24219L28.6482 12.1593C27.7574 12.9279 27.0762 13.9235 26.6395 15.0414L20.9626 9.94093Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3);
export default __webpack_public_path__ + "static/media/w3.a490b317344f951bef4c237cb19ed422.svg";
export { ForwardRef as ReactComponent };